import { App } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosCustomError } from 'services/http';
import { http } from 'services/http';
import { CONTACTS_GET_MANY } from 'api/query-keys.ts';
import type { ContactRes } from 'api/swagger';

export const useDeleteContact = (contactId: number) => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const res = await http.delete<ContactRes>(`/v1/contacts/${contactId}`);
      await queryClient.invalidateQueries({ queryKey: [CONTACTS_GET_MANY] });
      return res.data;
    },
    onError: (error) => {
      const { message: errorMessage, key } = (error as AxiosCustomError)?.response?.data || {};
      void message.error(errorMessage || key);
    },
  });
};
